import moment from 'moment';

/**
 * Return the next payment date given the number of months.
 * @link https://momentjs.com/#format-dates
 *
 * @param months
 * @param format
 * @returns {string}
 */
export function nextPaymentDay(months, format = 'MMM DD[,] YYYY') {
    moment.locale('es');
    return moment().add(months, 'months').format(format);
}

/**
 * Return brand logo.
 *
 * @param brand
 * @returns {string}
 */
export function toBrandLogo(brand) {
    switch (brand) {
        case 'visa':
            return '/images/visa.png';
        case 'mastercard':
            return '/images/mastercard.png';
        case 'amex':
            return '/images/amex.png';
        default:
            return '/images/card.svg';
    }
}

/**
 * Format a number from thousands to K style.
 *
 * @param number
 * @returns {(string|number)}
 */
export function toLikes(likes) {
    return Math.abs(likes) > 999
        ? Math.sign(likes) * (Math.abs(likes) / 1000).toFixed(1) + 'K'
        : Math.sign(likes) * Math.abs(likes);
}
